import qs from 'qs'
import { get } from 'lodash-es'

export function getBaseUrl () {
  if (
    process.env.NODE_ENV === 'production'
  ) {
    const domain = window.location.host.replace('-pc', '')
    let baseUrl
    if (domain.match(/-((stg)|(prd)|(pre)|(gra)|(dev))/g)) {
      baseUrl = domain.replace(/((local|dev|stg|pre|gra)?\.(huolala|huolalamove)\.(cn|com|net))/gm, 'api-$1')
    } else {
      baseUrl = domain.replace(/hpay-charge/g, 'hpay-charge-api')
    }
    const pro = window.location.protocol
    return `${pro}//${baseUrl}`
  } else {
    return '/'
  }
}

export function getSearchParams () {
  return qs.parse(get(window, 'location.search', '').replace('?', ''))
}
